import React, { useState } from "react";
import { Formik } from "formik";
import axios from "axios";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import * as Yup from "yup";
import { Input, message } from "antd";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function SignUp() {
  const [initialState, setInitialState] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    isApproved: "Waiting for approval",
    approvedBy: null,
    approvedWhen: null,
    isActive: false,
    role: "Unknown",
  });
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, "Name is too short!")
      .max(50, "Name is too long!")
      .required("Full Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  return (
    <div className="auth-wrapper">
      <div className="auth-inner">
        <Formik
          initialValues={initialState}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            var url = window.API_PREFIX + "users/api/post/register";
            const requestOptions = {
              data: values,
            };
            setLoading(true);
            axios
              .post(url, requestOptions)
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  window.location = "/Login";
                }
              })
              .catch((err) => {
                if (err.response.data[0]) {
                  message.error(err.response.data[0]);
                } else {
                  message.error("An error occurred during registration.");
                }
              })
              .finally(() => setLoading(false));
          }}
        >
          {({ handleSubmit, values, setFieldValue, errors, touched }) => (
            <div>
              <h3>Sign Up</h3>

              <div className="mb-3">
                <label>Full Name</label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Enter Full Name"
                  name="name"
                  value={values.name}
                  onChange={(e) => setFieldValue("name", e.target.value)}
                />
                {errors.name && touched.name && (
                  <span style={{ color: "red" }}>{errors.name}</span>
                )}
              </div>

              <div className="mb-3">
                <label>Email</label>
                <div>
                  <Input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email"
                    name="email"
                    value={values.email}
                    onChange={(e) => setFieldValue("email", e.target.value)}
                  />
                  {errors.email && touched.email && (
                    <span style={{ color: "red" }}>{errors.email}</span>
                  )}
                </div>
                <span
                  style={{
                    color: "rgb(143 143 143)",
                    fontSize: "small",
                    fontWeight: 600,
                  }}
                >
                  Please provide a valid email address for future communication*
                </span>
              </div>

              <div className="mb-3">
                <label>Password</label>
                <Input.Password
                  placeholder="Enter password"
                  name="password"
                  value={values.password}
                  onChange={(e) => setFieldValue("password", e.target.value)}
                  iconRender={(visible) =>
                    visible ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />
                  }
                />
                {errors.password && touched.password && (
                  <span style={{ color: "red" }}>{errors.password}</span>
                )}
              </div>

              <div className="mb-3">
                <label>Confirm password</label>
                <Input.Password
                  placeholder="Enter password again"
                  name="confirmPassword"
                  value={values.confirmPassword}
                  onChange={(e) =>
                    setFieldValue("confirmPassword", e.target.value)
                  }
                  iconRender={(visible) =>
                    visible ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />
                  }
                />
                {errors.confirmPassword && touched.confirmPassword && (
                  <span style={{ color: "red" }}>{errors.confirmPassword}</span>
                )}
              </div>

              <div className="d-grid">
                <button type="submit" className="btn" onClick={handleSubmit}>
                  Sign Up
                </button>
              </div>
              <p className="forgot-password text-right">
                Already registered <a href="/Login">sign in?</a>
              </p>
            </div>
          )}
        </Formik>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
}
export default SignUp;
